// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1z555","disabled":"FileBtn_disabled__2ZH2R","warn":"FileBtn_warn__SvWCJ","fade":"FileBtn_fade__3mzuB"};